import React from 'react';
import { Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { ThspianAvatar } from '../../../Avatar/ThspianAvatar';
import { IUserSummary } from '../../../../types/global/helper';
import {
    BRAND_LUXE_BG,
    BRAND_LUXE_PRIMARY,
    BRAND_LUXE_SECONDARY,
} from '../../../../pages/BrandDashboard/brandDashboardTokens';

/** Theme mint — matches compact card / mobile invitation status. */
export const BRAND_JUROR_AVATAR_ACCEPTED = BRAND_LUXE_SECONDARY;
/** Amber — pending invite badge. */
export const BRAND_JUROR_AVATAR_PENDING = BRAND_LUXE_PRIMARY;

export interface BrandContestJurorAvatarProps {
    user: IUserSummary | undefined;
    acceptedInvite: boolean;
    /** Avatar diameter in px. */
    size?: number;
}

const BrandContestJurorAvatar: React.FC<BrandContestJurorAvatarProps> = ({
    user,
    acceptedInvite,
    size = 44,
}) => {
    const badgeSize = size >= 52 ? 16 : 14;
    const iconSize = badgeSize >= 16 ? 11 : 9;

    return (
        <Box sx={{ position: 'relative', flexShrink: 0, lineHeight: 0 }}>
            <ThspianAvatar
                user={user}
                disableVerified
                sx={{
                    width: size,
                    height: size,
                    borderRadius: '50%',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none',
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    bottom: -2,
                    right: -2,
                    width: badgeSize,
                    height: badgeSize,
                    borderRadius: '50%',
                    bgcolor: BRAND_LUXE_BG,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: '2px',
                    zIndex: 1,
                }}>
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        bgcolor: acceptedInvite ? BRAND_JUROR_AVATAR_ACCEPTED : BRAND_JUROR_AVATAR_PENDING,
                        boxShadow: acceptedInvite
                            ? '0 0 8px rgba(0, 253, 193, 0.6)'
                            : '0 0 8px rgba(255, 201, 101, 0.4)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                    {acceptedInvite ? (
                        <CheckIcon
                            sx={{
                                fontSize: iconSize,
                                color: BRAND_LUXE_BG,
                                fontWeight: 700,
                            }}
                        />
                    ) : (
                        <MoreHorizIcon
                            sx={{
                                fontSize: iconSize + 1,
                                color: BRAND_LUXE_BG,
                            }}
                        />
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export { BrandContestJurorAvatar };
